<template>
  <div class="deposit_page">
    <CustomHeader :text="$t('common.deposite')" :isPopupCloseBackIcon="true" :show-fund="true" :is-finalizar="true"  @closePopup="close"  @go-to-fund="goToFundEmit" :bgColor="'#024A49'"/>

    <div class="content">

      <ul class="instructions">
        <li>
            {{ $t('deposit.qrInstruction1') }}
        </li>

        <li>
           {{ $t('deposit.qrInstruction2') }}
         
        </li>

        <li class="success_text">
           {{ $t('deposit.qrInstruction3') }}
        </li>
      </ul>

      <div class="amount">
        <span>R$ {{ selectedAmountVal }}</span>

        <img
          src="@/assets/common/copy.png"
          class="copy_icon"
          @click="copyAmount"
        />
      </div>

      <div class="qr_container">

      <!-- Loader -->
      <div v-if="loading" class="loader_container">
        <van-loading type="spinner" size="30px" />
      </div>

      <!-- Iframe -->
      <iframe
        v-if="iframeUrl"
        :src="iframeUrl"
        frameborder="0"
        @load="iframeLoaded"
      ></iframe>

</div>

    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import CustomHeader from '../../components/common/customHeader.vue'
import { showToast } from 'vant';
const props = defineProps({
  show: Boolean,
  iframeUrl: String,
  selectedAmountVal : Number
})

const emit = defineEmits(['close','goTo'])

const loading = ref(true)

const iframeLoaded = () => {
  loading.value = false
}

watch(() => props.iframeUrl, () => {
  loading.value = true
})
const close = () => {
  emit('close')
}

const goToFundEmit = () => {
  emit('goTo')
}

const copyAmount = async () => {
  try {
    await navigator.clipboard.writeText(String(props.selectedAmountVal))
    showToast('Cópia Bem-sucedida');
  } catch (err) {
    console.error('Failed to copy: ', err)
  }
}


</script>
<style scoped>

.deposit_page {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: #003231;
  z-index: 9999;
  display: flex;
  flex-direction: column;
}

.content {
  padding: 20px;
  margin-top: 60px;

  display: flex;
  flex-direction: column;
  height: calc(100vh - 60px); 
}


.qr_container {
  flex: 1;       
  width: 100%;
  background: #035B59;
  margin-top: 10px;
  padding: 5px;
  border-radius: 6px;
  position: relative;
  display: flex;}

.content::-webkit-scrollbar {
  display: none;
}


.qr_container iframe {
  flex: 1;             
  width: 100%;
  border: none;
  background: #035B59;
}

/* instruction text */
.instructions {
  list-style: disc;
  padding-left: 20px;
  color: #FFF;
  font-size: 15px;
  line-height: 1.6;
}

.instructions li {
  margin-bottom: 10px;
}

/* blue text */
.success_text {
  color: #2da3ff;
}

/* amount text */
.amount {
  text-align: center;
  font-size: 26px;
  font-weight: bold;
  color: #f8a63a;
  margin: 20px 0;
}

.copy_icon{
  margin-left: 10px;
  width: 18px;
  height: 18px;
  cursor: pointer;
}



/* iframe */


.loader_container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>